module.exports = __webpack_public_path__ + "img/img44.c42c0991.svg";